import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { HaloUnsubscribeService } from './halo-unsubscribe.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { HaloLoaderService } from '../../core/halo-loader/halo-loader.service';

import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-halo-unsubscribe',
  templateUrl: './halo-unsubscribe.component.html',
  styleUrls: ['./halo-unsubscribe.component.scss']
})
export class HaloUnsubscribeComponent implements OnInit {

  cloudBasePath: string;
  selectedLang: string | null;
  showContent: boolean = false;
  rootScopeData:RootScopeDeclare;
  constructor(private route:ActivatedRoute, private haloUnsubscribeService:HaloUnsubscribeService, 
    private rootScopeService: RootScopeService, public translate: TranslateService, private loader: HaloLoaderService) { }

  ngOnInit() {
    this.getRootScopeData();
    this.cloudBasePath = environment.cloudBasePath;
    const firstParam = <string | null>this.route.snapshot.queryParamMap.get('token');
    
    this.selectedLang= this.route.snapshot.queryParamMap.get('lang');
    this.loader.startProcess();
    if(firstParam){
      this.haloUnsubscribeService.unsubscribe(firstParam).subscribe(
        data => {
          this.showContent = true;
          this.loader.endProcess();
        },
        error => {
          console.error('API failed.');
          this.showContent = false;
          this.loader.endProcess();
        }
      );
    }
    if(this.selectedLang)
      this.translate.use(this.selectedLang)  
    .subscribe((res: any) => 
      {
        this.rootScopeData.translationsLoaded = true;
      });
    if (this.selectedLang === 'ar' || this.selectedLang === 'he') {
      this.rootScopeService.changeToRtl();
    } else {
      this.rootScopeService.changeToLtr();
    }
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }


}
